import type { ChatOption } from '../types/chat';

/** The three blue quick-picks that pop up when you hover Pixel in the corner */
export const dockTopics: ChatOption[] = [
  { label: 'Clients', next: 'dock-clients', reaction: 'curious' },
  { label: 'Work', next: 'dock-work', reaction: 'happy' },
  { label: 'Contact', next: 'dock-contact', reaction: 'surprised' },
];
